import React from 'react';
import { TaskDefinition } from '../../graphql/schema';
import Illustration from '../base/Illustration';

interface Props {
  taskDefinition: TaskDefinition;
  children?: any;
}

const TaskDefinitionHeader = ({ taskDefinition, children }: Props) => {
  return (
    <div className="w-full relative">
      {children}
      <div className="flex lg:space-x-4 mb-5 relative">
        <div className="hidden lg:block w-full max-w-[80px]">
          <Illustration id={taskDefinition.illustration} className="w-full" />
        </div>
        <div className="flex-1">
          <div className="text-lg font-semibold">{taskDefinition.title}</div>
          <p className="text-sm">{taskDefinition.description}</p>
        </div>
      </div>
    </div>
  );
};

export default TaskDefinitionHeader;
